var map = {
	"./book.svg": "fc4e",
	"./construction.svg": "ff88",
	"./discord.svg": "e3a3",
	"./facebook.svg": "8485",
	"./gmail.svg": "5bde",
	"./light-bulb.svg": "84e7",
	"./linkedin-logo.svg": "5200",
	"./shuffle.svg": "00e6",
	"./telegram.svg": "2b29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";